<template>
  <div class="guidance1">
    <div class="navigation-bars">
      <div class="middle-menu" v-if="staData">
        <div class="middle-menu-item">
          <span class="middle-menu-title">待检定</span>
          <span class="middle-menu-content">
            <span v-if="staData.needVertify>0" class="middle-menu-content-jump" @click="toUsedMsg">
              <el-badge :value="staData.needVertify"></el-badge>
            </span>
            <span v-else class="middle-menu-content">
              <el-badge :value="staData.needVertify" type="success"></el-badge>
            </span>
          </span>
        </div>
        <div class="middle-menu-item">
          <span class="middle-menu-title">待保养</span>
          <span class="middle-menu-content">
            <span v-if="staData.needMaintain>0" class="middle-menu-content-jump" @click="toUsedMsg">
              <el-badge :value="staData.needMaintain"></el-badge>
            </span>
            <span v-else class="middle-menu-content">
              <el-badge :value="staData.needMaintain" type="success"></el-badge>
            </span>
          </span>
        </div>
        <div class="middle-menu-item">
          <span class="middle-menu-title">待维修</span>
          <span class="middle-menu-content">
            <span v-if="staData.needFix>0" class="middle-menu-content-jump" @click="toUsedMsg">
              <el-badge :value="staData.needFix"></el-badge>
            </span>
            <span v-else class="middle-menu-content">
              <el-badge :value="staData.needFix" type="success"></el-badge>
            </span>
          </span>
        </div>
        <div class="middle-menu-item">
          <span class="middle-menu-title">待充电</span>
          <span class="middle-menu-content">
            <span v-if="staData.needCharge>0" class="middle-menu-content-jump" @click="toEquipment">
              <el-badge :value="staData.needCharge"></el-badge>
            </span>
            <span v-else class="middle-menu-content">
              <el-badge :value="staData.needCharge" type="success"></el-badge>
            </span>
          </span>
        </div>
        <div class="middle-menu-item">
          <span class="middle-menu-title">逾期申请</span>
          <span v-if="staData.overdue>0" class="middle-menu-content-jump" @click="toAppMan">
            <el-badge :value="staData.overdue"></el-badge>
          </span>
          <span v-else class="middle-menu-content">
            <el-badge :value="staData.overdue" type="success"></el-badge>
          </span>
        </div>
      </div>
      <div class="right-menu">
        <div class="user-avator right-menu-item">
          <img v-if="userInfo.avatar" class="user-header" :src="userInfo.avatar" />
          <img v-else src="@/assets/images/default.jpg" alt="">
        </div>
        <div class="name right-menu-item">{{ userInfo.nickname }}</div>
        <div class="setting right-menu-item">
          <el-dropdown trigger="click">
            <i class="el-icon-setting"></i>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item @click.native="changePaw">修改密码</el-dropdown-item>
              <el-dropdown-item @click.native="uploadLogo">上传logo</el-dropdown-item>
              <el-dropdown-item @click.native="logAot">退出登录</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </div>
    </div>
    <div class="guidance-content">
      <div class="logo-img">
        <img class="login-logo" :src="deptLogo" alt="" />
        <h2 class="login-title">仪器智能系统</h2>
      </div>
      <div class="cards-list">
        <div class="card" @click="goEquipment">
          <div class="card-icon">
            <i class="iconfont icon-shebei"></i>
          </div>
          <div class="card-foter">仪器管理</div>
        </div>
        <div class="card" @click="goWarehouse">
          <div class="card-icon">
            <i class="iconfont icon-storehouse-mgt" style="color:#74c8fe"></i>
          </div>
          <div class="card-foter">库房管理</div>
        </div>
        <div class="card" @click="goEmploy">
          <div class="card-icon">
            <i class="iconfont icon-jilu1"></i>
          </div>
          <div class="card-foter">使用管理</div>
        </div>
        <div class="card" @click="goDatamana">
          <div class="card-icon">
            <i class="iconfont icon-shezhi"></i>
          </div>
          <div class="card-foter">资料管理</div>
        </div>
      </div>
      <div class="footer">
        <span>
          <img src="@/assets/images/logo1.png" />
        </span>
        <div class="useSMS" @click="toDowSMS">
          <span>仪器智能系统操作手册</span>
          <i class="el-icon-info"></i>
        </div>
      </div>
    </div>

    <!-- 修改密码弹框 -->
    <div class="popout model">
      <el-dialog title="修改密码" width="500px" :visible.sync="outerVisible" :close-on-click-modal="false">
        <el-form v-if="outerVisible" :model="ruleForm" status-icon ref="ruleForm" label-width="150px" class="demo-ruleForm">
          <el-form-item label="新密码">
            <el-input type="password" v-model="ruleForm.pass" autocomplete="off" placeholder="请输入密码"></el-input>
          </el-form-item>
          <el-form-item label="确认密码">
            <el-input type="password" v-model="ruleForm.checkPass" placeholder="请输入确认密码" autocomplete="off"></el-input>
          </el-form-item>
          <div class="row-item footer">
            <div class="element-list jb-bg btn" @click="submitForm('ruleForm')">
              确认
            </div>
            <div class="element-list btn" @click="resetForm('ruleForm')">
              取消
            </div>
          </div>
        </el-form>
      </el-dialog>
    </div>

    <el-dialog class="popout" width="448px" title="文件上传弹框" :visible.sync="logoVisible" append-to-body center>
      <myFiles @fileChange="onChange" @cancel="fileCancel"></myFiles>
    </el-dialog>
  </div>
</template>

<script>
import { getDepotInfo, getIndexData, FileUrl } from "@/api/depotApi";
import { updatePasw } from "@/api/userApi";
import myFiles from "./components/uploadLogo";
export default {
  components: {
    myFiles,
  },
  data() {
    return {
      deptId: "", //单位id
      outerVisible: false,
      logoVisible: false,
      ruleForm: {
        pass: "",
        checkPass: "",
      },
      staData: {},
      deptName: "",
      deptLogo: "",
    };
  },
  mounted() {
    this.deptName = this.$store.state.user.deptName;
    this.deptLogo = this.$store.state.user.deptLogo;
    this.depostInfo();
    this.getDataDetail();
  },
  computed: {
    userInfo() {
      return this.$store.state.user.userInfo;
    },
  },
  methods: {
    getDataDetail() {
      let self = this;
      getIndexData().then((res) => {
        if (res.code == "200") {
          self.staData = res.data;
        }
      });
    },
    submitForm(formName) {
      let that = this;
      if (this.ruleForm.pass.length < 6 && this.ruleForm.checkPass.length < 6) {
        this.$message.warning("密码长度不能小于6位");
        return;
      }
      if (this.ruleForm.pass != this.ruleForm.checkPass) {
        this.$message.warning("两次密码不一致！请重新输入");
        return;
      }
      updatePasw({ id: that.userInfo.userId, psw: that.ruleForm.pass }).then(
        (res) => {
          that.$message.success(res.msg || "密码修改成功！");
          that.resetForm();
          that.$store.dispatch("Logout").then(() => {
            setTimeout(() => {
              that.$router.replace({ path: "/login" });
            }, 1000);
          });
        }
      );
    },
    resetForm(formName) {
      this.ruleForm.pass = "";
      this.ruleForm.checkPass = "";
      this.outerVisible = false;
    },
    //获取仓库数据
    depostInfo() {
      getDepotInfo({ deptId: this.userInfo.deptId }).then((res) => {
        if (res.code == "200") {
          let btnData = res.data;
          this.$store.dispatch("setDepotList", btnData);
        }
      });
    },
    //调整方法
    goEquipment() {
      this.$router.push({ path: "/instaru/equipment" });
    },
    goWarehouse() {
      this.$router.push({ path: "/warehouse/warehousemana" });
    },
    goEmploy() {
      this.$router.push({ path: "/employ/maintenance" });
    },
    goDatamana() {
      this.$router.push({ path: "/data/applicationmana" });
    },
    // 修改密码
    changePaw() {
      this.outerVisible = true;
    },
    // 上传logo
    uploadLogo() {
      this.logoVisible = true;
    },
    // 上传logo - 取消
    fileCancel() {
      this.logoVisible = false;
    },
    // 上传logo - 确定
    onChange(res) {
      this.deptLogo = res;
      this.$store.state.user.deptLogo = res;
      this.logoVisible = false;
    },
    // 退出登录
    logAot() {
      this.$store.dispatch("Logout").then(() => {
        setTimeout(() => {
          this.$message.success("退出成功");
          this.$router.replace({ path: "/login" });
        }, 1000);
      });
    },
    toDowSMS() {
      let self = this;
      FileUrl({ objectName: "Templates/智能柜系统说明文档.pdf" }).then(
        (res) => {
          if (res.code == "200") {
            window.open(res.data);
          } else {
            this.$message.error(res.msg || "获取下载地址失败！");
          }
        }
      );
    },
    toUsedMsg() {
      let self = this;
      self.$router.push({ path: "/employ/maintenance" });
    },
    toEquipment() {
      let self = this;
      self.$router.push({
        path: "/instaru/equipment",
        query: {
          IsNeedCharge: 1,
        },
      });
    },
    toAppMan() {
      let self = this;
      self.$router.push({
        path: "/data/applicationmana",
        query: {
          IsOverdue: 1,
        },
      });
    },
  },
};
</script>

<style lang="less" scoped>
.guidance1 {
  height: 100%;
  background-color: #10528c;
  background-image: url("~@/assets/images/bg.png");
  background-repeat: no-repeat;
  background-size: 100% 100%;
  -moz-background-size: 100% 100%;
  position: relative;
  color: #74c8fe;
  .navigation-bars {
    height: 60px;
    display: flex;
    justify-content: flex-end;
    .left-menu {
      height: 100%;
      line-height: 60px;
      color: #ffffff;
      .left-menu-item {
        display: inline-block;
        padding: 0 8px;
        height: 100%;
        font-size: 18px;
        vertical-align: text-bottom;
        i {
          color: #ffffff;
          font-size: 24px;
        }
      }
    }

    .middle-menu {
      height: 60px;
      .middle-menu-item {
        display: inline-block;
        margin-right: 20px;
        font-size: 18px;
        line-height: 60px;
        .middle-menu-title {
          color: #ffffff;
        }
        .middle-menu-content {
          color: red;
        }
        @keyframes fade {
          from {
            opacity: 1;
          }
          50% {
            opacity: 0.4;
          }
          to {
            opacity: 1;
          }
        }

        @-webkit-keyframes fade {
          from {
            opacity: 1;
          }
          50% {
            opacity: 0.4;
          }
          to {
            opacity: 1;
          }
        }
        .middle-menu-content-jump {
          animation: fade 600ms infinite;
          -webkit-animation: fade 600ms infinite;
          cursor: pointer;
        }
      }
    }
    .right-menu {
      height: 60px;
      margin-right: 20px;
      line-height: 60px;
      color: #ffffff;
      .user-avator {
        img {
          width: 40px;
          height: 40px;
          margin-top: 7px;
          border-radius: 50%;
        }
      }
      .setting {
        i {
          color: #ffffff;
          font-size: 24px;
          cursor: pointer;
        }
      }
      .right-menu-item {
        display: inline-block;
        padding: 0 8px;
        height: 100%;
        font-size: 18px;
        vertical-align: text-bottom;
      }
    }
  }
  .guidance-content {
    height: calc(100% - 60px);
    padding: 0 3%;
    overflow-y: hidden;
    .logo-img {
      width: 100%;
      margin: 0 auto;
      .login-logo {
        height: 70px;
        margin-bottom: 30px;
        min-height: 70px;
      }
      .login-title {
        color: #7ec4ff;
        font-size: 42px;
        font-family: 宋体;
      }
    }
    .cards-list {
      width: 100%;
      margin: 0 auto;
      height: calc(83% - 180px);
      max-height: 540px;
      min-height: 480px;
      margin-top: 2%;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .card {
        width: 23%;
        height: 96%;
        border: 6px solid #026bb2;
        border-radius: 8px;
        overflow: hidden;
        position: relative;
        cursor: pointer;
        .card-icon {
          width: 100%;
          height: 85%;
          display: flex;
          align-items: center;
          justify-content: center;
          i {
            font-size: 200px;
            background-image: linear-gradient(150deg, #01bbec, #045478);
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
          }
        }
        .card-foter {
          width: 100%;
          height: 15%;
          color: #7fc4fb;
          display: flex;
          font-size: 26px;
          align-items: center;
          justify-content: center;
          background: linear-gradient(
            180deg,
            rgba(0, 210, 255, 0.52),
            rgba(0, 57, 142, 0.52)
          );
        }
      }
      .card:hover {
        box-shadow: 0 0 30px rgb(240, 239, 239);
        transform: scale(1.03);
      }
    }
    .footer {
      margin-top: 30px;
      margin-bottom: 10px;
      text-align: center;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      .useSMS {
        cursor: pointer;
        margin-top: 20px;
      }
    }
    // background: blue;
  }
  .popout {
    /deep/.el-form-item {
      border: 2px solid #0090f0;
      border-radius: 6px;
      height: 40px;
      line-height: 40px;
      margin: 20px 0;
      text-align: center;
      .el-form-item__label {
        background-image: linear-gradient(#0479b4, #02407e);
        text-align: center;
        color: #74c8fe;
      }
    }
    .footer {
      display: flex;
      justify-content: center;
      color: #74c8fe;
      .element-list {
        width: 150px;
        cursor: pointer;
        border: 2px solid #0090f0;
        border-radius: 6px;
        height: 30px;
        line-height: 30px;
        margin: 10px 0;
        margin-right: 10px;
        text-align: center;
      }
    }
  }
  .jb-bg {
    background-image: linear-gradient(#0479b4, #02407e);
  }
}
</style>



// WEBPACK FOOTER //
// src/views/guidance/index.vue